 /**
  * Página exibida quando usuário tenta acessar módulo inativo
  * 
  * Exibe informações do módulo e CTAs para ativar
  */
 
 import { useNavigate } from 'react-router-dom';
 import { MODULES_REGISTRY, ModuleId } from '@/config/modules';
 import { Button } from '@/components/ui/button';
 import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
 import { Badge } from '@/components/ui/badge';
 import { Check, Sparkles, MessageSquare, ArrowLeft } from 'lucide-react';
 
 interface ModuleLockedPageProps {
   moduleId: ModuleId;
 }
 
 export const ModuleLockedPage = ({ moduleId }: ModuleLockedPageProps) => {
   const navigate = useNavigate();
   const module = MODULES_REGISTRY[moduleId];
   const Icon = module.icon;
 
   const handleRequestActivation = () => {
     window.open(
       `https://wa.me/5511999999999?text=Olá! Gostaria de ativar o módulo ${module.name} no meu GOnX.`,
       '_blank'
     );
   };
 
   const handleGoToMarketplace = () => {
     navigate('/dashboard/settings', { state: { tab: 'modules' } });
   };
 
   return (
     <div className="min-h-[80vh] flex items-center justify-center p-6">
       <Card className="max-w-2xl w-full border-dashed">
         <CardHeader className="text-center pb-4">
           <Button 
             variant="ghost" 
             size="sm" 
             className="absolute left-4 top-4"
             onClick={() => navigate(-1)}
           >
             <ArrowLeft className="h-4 w-4 mr-1" />
             Voltar
           </Button>
           
           <div className={`mx-auto p-4 rounded-2xl ${module.color} mb-4`}>
             <Icon className="h-12 w-12" />
           </div>
           <CardTitle className="text-2xl">{module.name}</CardTitle>
           <CardDescription className="text-base">
             {module.description}
           </CardDescription>
           {module.price && (
             <Badge variant="secondary" className="mx-auto mt-2">
               A partir de R$ {module.price}/mês
             </Badge>
           )}
         </CardHeader>
         
         <CardContent className="space-y-6">
           {/* Features */}
           <div className="grid gap-2">
             <h4 className="text-sm font-medium text-muted-foreground mb-1">
               O que você terá acesso:
             </h4>
             {module.features.map((feature, i) => (
               <div key={i} className="flex items-center gap-2 text-sm">
                 <Check className="h-4 w-4 text-emerald-500 shrink-0" />
                 <span>{feature}</span>
               </div>
             ))}
           </div>
 
           {/* CTA Buttons */}
           <div className="flex flex-col sm:flex-row gap-3 pt-4">
             <Button 
               className="flex-1 gap-2" 
               onClick={handleRequestActivation}
             >
               <Sparkles className="h-4 w-4" />
               Solicitar Ativação
             </Button>
             <Button 
               variant="outline" 
               className="flex-1 gap-2"
               onClick={handleGoToMarketplace}
             >
               <MessageSquare className="h-4 w-4" />
               Ver Todos os Módulos
             </Button>
           </div>
 
           <p className="text-xs text-muted-foreground text-center">
             Teste grátis por 7 dias. Sem compromisso.
           </p>
         </CardContent>
       </Card>
     </div>
   );
 };